import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { InputWithErrorComponent } from '@nimmsta/ng-commons-lib/forms';
import { SoftwareType } from '@nimmsta/ng-commons-lib/models';
import { SoftwareLabelFormComponent } from './software-label-form.component';
import { SoftwareTypeService } from '../../services/software/software-type.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-software-type-form',
  templateUrl: './software-label-form.component.html',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputWithErrorComponent,
    ErrorComponent,
  ],
})
export class SoftwareTypeFormComponent extends SoftwareLabelFormComponent {
  protected override dataService = inject(SoftwareTypeService);

  constructor() {
    super();
    this.setValue(new SoftwareType());
  }
}
